import styled from 'styled-components/macro';
import { Input } from 'antd';

export const StyledRow = styled.div`
    display: flex;
    width: 100%;
    align-items: center;

    @media (max-width: 767px) {
        display: block;

        > div {
            margin: 1em 0;

            &:first-of-type {
                margin-top: .5em;
            }

            &:last-of-type {
                margin-bottom: .5em;
            }
        }
    }
`;

export const StyledInput = styled(Input)`
    margin-bottom: 0;
    
    &:first-of-type {
        width: 70% !important;
    }
`;
